<template>
  <md-dialog v-bind="$attrs" v-on="$listeners" :md-fullscreen="false">
    <md-dialog-title v-if="mdTitle">{{ mdTitle }}</md-dialog-title>

    <!-- 選択件数-->
    <md-dialog-content v-if="selectedRegistries !== null">
      <md-table>
        <md-table-toolbar>
          選択件数：<span>{{
            selectedRegistries.pdfTypeWholeData +
            selectedRegistries.pdfTypeOwnerData +
            selectedRegistries.pdfTypeMap +
            selectedRegistries.pdfTypeLandSurveyMap +
            selectedRegistries.pdfTypeEasementDrawing +
            selectedRegistries.pdfTypeBuildingDrawing
          }}</span>件
        </md-table-toolbar>
        <md-table-row>
          <md-table-head>全部事項</md-table-head>
          <md-table-head>所有者事項</md-table-head>
          <md-table-head>地図（公図）</md-table-head>
          <md-table-head>地積測量図<br>／建物図面</md-table-head>
          <md-table-head>地役権図面</md-table-head>
        </md-table-row>
        <md-table-row>
          <md-table-cell md-numeric>{{ selectedRegistries.pdfTypeWholeData }}<span>件</span></md-table-cell>
          <md-table-cell md-numeric>{{ selectedRegistries.pdfTypeOwnerData }}<span>件</span></md-table-cell>
          <md-table-cell md-numeric>{{ selectedRegistries.pdfTypeMap }}<span>件</span></md-table-cell>
          <md-table-cell md-numeric>
            {{ selectedRegistries.pdfTypeLandSurveyMap + selectedRegistries.pdfTypeBuildingDrawing }}<span>件</span>
          </md-table-cell>
          <md-table-cell md-numeric>{{ selectedRegistries.pdfTypeEasementDrawing }}<span>件</span></md-table-cell>
        </md-table-row>
      </md-table>
      <div class="md-layout warning-box mt-3" v-if="hasWarning">
        <div class="md-layout-item md-large-size-10 md-alignment-center-center">
          <md-icon class="icon">warning</md-icon>
        </div>
        <div class="md-layout-item md-large-size-90">
          選択された登記情報の中に、お客様のアカウントもしくは<br/>
          同一法人内の別アカウントにて、取得済みの登記情報が存在します。<br/>
          <span class="font-weight-bold text-danger text-underline">再取得しますか？</span>
        </div>
      </div>
      <div class="md-layout" v-if="hasWarning">
        <div class="md-layout-item md-large-size-100">
          ※過去に取得済みの登記情報のご確認は、取得画面の該当箇所にて<br/>
          青字箇所(例：「<span class="text-link">{{ currentMonth() }}</span>」)をクリックしてください。<br/>
          もしくは、地図上のマイマーカーからご確認ください。
        </div>
      </div>
      <div class="md-layout mt-3" v-if="mdContent">
        <div class="md-layout-item md-large-size-100" v-html="mdContent">
        </div>
      </div>
    </md-dialog-content>
    <md-dialog-content v-else>
      <div class="md-layout mt-3" v-if="mdContent">
        <div class="md-layout-item md-large-size-100" v-html="mdContent">
        </div>
      </div>
    </md-dialog-content>

    <md-dialog-actions>
      <md-button :class="'md-raised ' + cancelButtonClass" @click="onCancel">
        <md-icon>close</md-icon>
        <span>{{ mdCancelText }}</span>
      </md-button>
      <md-button :class="'md-raised md-primary ' + confirmButtonClass" @click="onConfirm" v-if="showPrimaryButton">
        <md-icon>check</md-icon>
        <span>{{ mdConfirmText }}</span>
      </md-button>
    </md-dialog-actions>
    <loading-spinner-overlay v-if="sending" :background="background"></loading-spinner-overlay>
  </md-dialog>
</template>

<script>
import LoadingSpinnerOverlay from "./LoadingSpinnerOverlay";
import moment                from "moment-timezone";
import Common                from "../modules/common";

export default {
  name      : 'ConfirmModal',
  components: {LoadingSpinnerOverlay},
  props     : {
    mdTitle           : String,
    mdContent         : String,
    hasWarning        : {
      type   : Boolean,
      default: false,
    },
    mdConfirmText     : {
      type   : String,
      default: 'はい'
    },
    mdCancelText      : {
      type   : String,
      default: 'いいえ'
    },
    confirmButtonClass: {
      type   : String,
      default: null,
    },
    cancelButtonClass : {
      type   : String,
      default: null,
    },
    sending           : {
      type    : Boolean,
      required: false,
      default : false,
    },
    background        : {
      type   : String,
      default: 'transparent',
    },
    selectedRegistries: {
      type   : Array | null,
      default: null
    },
    showPrimaryButton: {
      type    : Boolean,
      required: false,
      default : true
    }
  },
  methods   : {
    onCancel() {
      this.$emit('md-cancel');
      this.$emit('update:mdActive', false)
    },
    onConfirm() {
      this.$emit('md-confirm');
    },
    currentMonth() {
      return moment().format(Common.momentConst.dateFormatPdf);
    },
  }
}
</script>

<style lang="scss" scoped>
.md-table-head,
.md-table-cell {
  min-width: 9em;
  max-width: 9em;
  border: solid 1px rgba(0, 0, 0, 0.2);
}

.md-table-head {
  ::v-deep(.md-table-head-container) {
    text-align: center;
    padding: 9px 0;
    height: 48px;
    background-color: #f0f0f0;

    .md-table-head-label {
      display: inline-table;
      line-height: 14px;
    }
  }
}

.md-table-cell {
  ::v-deep(.md-table-cell-container) {
    font-size: 16px;

    span {
      margin-left: 0.2em;
      font-size: 12px;
    }
  }
}

.md-toolbar {
  min-height: 2em;
  padding: 0;
  align-content: flex-end;

  span {
    font-size: 18px;
  }
}

.warning-box {
  background: #FFFFDD;
  border: orange 2px solid;
  margin-bottom: 5px;

  .md-layout-item {
    padding: 5px;
  }

  .icon {
    width: 100%;
    height: 100%;
    font-size: 36px !important;
    color: orange;
    margin: 0 auto;
  }
}

.font-weight-bold {
  font-weight: bold;
}

.text-danger {
  color: red;
}

.text-underline {
  border-bottom: 1px red solid;
}

.text-link {
  color: #448aff;
}

.mt-3 {
  margin-top: 1rem !important;
}
</style>
